
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class FeatureLoaderAPI
 * @hideconstructor
 * @classdesc API class that is used to register features
 */
define([], () => {
	class FeatureLoaderAPI {

		/**
		 * @function FeatureLoaderAPI#registerFeature
		 * @description Register a feature
		 * @param {String} name
		 * @param {Object} feature
		 */
		registerFeature() {}

		/**
		 * @function FeatureLoaderAPI#updateCurrentProfile
		 * @description updates current profile
		 * @param {Object} params - parameters
		 * @param {Array} params.add - profiles to add
		 * @param {Array} params.remove - profiles to remove
		 * @private
		 */
		updateCurrentProfile() {}

		/**
		 * @function FeatureLoaderAPI#getCurrentProfile
		 * @description returns current profile
		 * @return {String[]}
		 * @private
		 */
		getCurrentProfile() {}

	}


	return FeatureLoaderAPI;
});
